import { render, staticRenderFns } from "./Card.vue?vue&type=template&id=64ab015d"
import script from "./Card.vue?vue&type=script&lang=js"
export * from "./Card.vue?vue&type=script&lang=js"
import style0 from "./Card.vue?vue&type=style&index=0&id=64ab015d&prod&lang=css"
import style1 from "./Card.vue?vue&type=style&index=1&id=64ab015d&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports